import Cookies from 'universal-cookie';
import { secureSet, secureRemove } from '../platform/secureStore';
import { storageSet, storageRemove } from '../platform/storage';
import { isNative } from '../platform/env';
import { unregisterPush } from '../platform/push';

const cookies = new Cookies();

// Token storage strategy:
//  - Web: cookie (existing behavior, scoped to host).
//  - Native (iOS/Android): encrypted secure store (Keychain / EncryptedSharedPreferences)
//    plus a non-sensitive `isLoggedIn` flag in Preferences for fast cold-start
//    checks. We also keep a cookie write-through on native to avoid breaking
//    any code path that still reads `cookies.get('isLoggedIn')`.

export const setTokenInCookie = (token) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 2); // Set the cookie to expire in 7 days
    cookies.set('isLoggedIn', { token: token }, { path: '/', expires: expires });

    if (isNative) {
        secureSet('authToken', token).catch(() => {});
        storageSet('isLoggedIn', '1').catch(() => {});
    }
};
export const clearTokenInCookie = () => {
    cookies.remove('isLoggedIn', { path: '/' });

    if (isNative) {
        secureRemove('authToken').catch(() => {});
        storageRemove('isLoggedIn').catch(() => {});
        // Logout clears stored email+password used by the biometric login,
        // but KEEPS the opt-in flag and the "asked" flag — so on the next
        // password login we silently re-stash creds and the user retains
        // their preference to use biometric.
        storageRemove('biometric:email').catch(() => {});
        secureRemove('biometric:password').catch(() => {});
        // Tear down the FCM registration so the backend stops dispatching to
        // this (now-logged-out) device. Fire-and-forget; safe to fail.
        unregisterPush().catch(() => {});
    }
};
